import { Component, inject } from '@angular/core';
import { LandingCardComponent } from '../../../../../common/components/landing-card/landing-card.component';
import { WhyJoinContraaAnimationComponent } from './why-join-contraa-animation/why-join-contraa-animation.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import {
  CpuSettingIconComponent,
  BrushIconComponent,
  ShareNetworkIconComponent,
  DocumentCodeIconComponent,
  SunIconComponent,
  PieChartIconComponent,
} from '@mars/ui-components';

@Component({
  selector: 'mars-why-join',
  standalone: true,
  imports: [
    LandingCardComponent,
    WhyJoinContraaAnimationComponent,
    TranslocoModule,
  ],
  templateUrl: './why-join.component.html',
  styleUrl: './why-join.component.scss',
})
export class WhyJoinComponent {
  translocoService = inject(TranslocoService);

  reasons = [
    {
      title: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_1_title'
      ),
      description: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_1_description'
      ),
      iconComponent: CpuSettingIconComponent,
    },

    {
      title: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_2_title'
      ),
      description: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_2_description'
      ),
      iconComponent: BrushIconComponent,
    },

    {
      title: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_3_title'
      ),
      description: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_3_description'
      ),
      iconComponent: ShareNetworkIconComponent,
    },

    {
      title: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_4_title'
      ),
      description: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_4_description'
      ),
      iconComponent: DocumentCodeIconComponent,
    },

    {
      title: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_5_title'
      ),
      description: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_5_description'
      ),
      iconComponent: SunIconComponent,
    },

    {
      title: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_6_title'
      ),
      description: this.translocoService.translate(
        'landing_page_why_join_contraa_section_card_6_description'
      ),
      iconComponent: PieChartIconComponent,
    },
  ];
}
